import type { ThemedToken } from '@shikijs/core';

import { ShikiStreamTokenizer } from './tokenizer';
import type { CodeToTokenTransformStreamOptions, RecallToken } from './types';

/**
 * Create a transform stream that takes code chunks and emits themed tokens.
 */
export class CodeToTokenTransformStream extends TransformStream<
  string,
  ThemedToken | RecallToken
> {
  readonly tokenizer: ShikiStreamTokenizer;
  readonly options: CodeToTokenTransformStreamOptions;

  constructor(options: CodeToTokenTransformStreamOptions) {
    const tokenizer = new ShikiStreamTokenizer(options);
    const { allowRecalls = false } = options;

    super({
      async transform(chunk, controller) {
        const {
          stable,
          unstable: buffer,
          recall,
        } = await tokenizer.enqueue(chunk);
        if (allowRecalls && recall > 0) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          controller.enqueue({ recall } as any);
        }
        for (const token of stable) {
          controller.enqueue(token);
        }
        if (allowRecalls) {
          for (const token of buffer) {
            controller.enqueue(token);
          }
        }
      },
      // eslint-disable-next-line @typescript-eslint/require-await
      async flush(controller) {
        const { stable } = tokenizer.close();
        // if allow recalls, the tokens should already be sent
        if (!allowRecalls) {
          for (const token of stable) {
            controller.enqueue(token);
          }
        }
      },
    });

    this.tokenizer = tokenizer;
    this.options = options;
  }
}
